import { render, staticRenderFns } from "./gshm.vue?vue&type=template&id=4bdbecf1&scoped=true&"
import script from "./gshm.vue?vue&type=script&lang=js&"
export * from "./gshm.vue?vue&type=script&lang=js&"
import style0 from "./gshm.vue?vue&type=style&index=0&id=4bdbecf1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdbecf1",
  null
  
)

export default component.exports